import { ComponentProps, useState, useEffect } from "react";
import Image from "next/image";
import { Interpolation, Theme, css, useTheme } from "@emotion/react";
import { Logo } from "components/core/Logo";

export const ContentThumbnailImg = ({
  src,
  onFallbackChange,
  ...props
}: {
  css?: Interpolation<Theme>;
  onFallbackChange?: (showFallback: boolean) => void;
} & Omit<ComponentProps<typeof Image>, "alt">) => {
  const theme = useTheme();
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Show fallback if no src or image failed to load
  const showFallback = !src || imageError
  
  // Notify parent component when fallback state changes
  useEffect(() => {
    onFallbackChange?.(showFallback);
  }, [showFallback, onFallbackChange]);

  if (showFallback) {
    return (
      <div
        css={[
          css`
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: ${theme.mode === "light" ? "#f5f5f5" : "#2a2a2a"};
            border-radius: 8px;

            @media (max-width: 768px) {
              border-radius: 8px;
              width: 70px;
              height: 70px;
            }
          `,
          props.css,
        ]}
      >
        <Logo
          css={css`
            width: 80px;
            color: ${theme.mode === "light" ? "#333333" : "#e0e0e0"};
            opacity: 0.4;

            @media (max-width: 768px) {
              width: 40px;
              height: 40px;
            }
          `}
        />
      </div>
    );
  }

  return (
    <Image
      css={css`
          object-fit: cover;
          object-position: center;
        `}
      alt="thumbnail"
      src={src}
      onError={() => setImageError(true)}
      onLoad={() => setImageLoaded(true)}
      {...props}
    />
  );
};
